module.exports = { 
  content: { 
    productDetail: "宝贝详情",
    productReviews: "商品评论",
    commodity: "商品问答",
  } 
} 


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/productDetail.js